import axios from 'axios';
import { Environment } from '../../../environment';
import { csrfInterceptor, errorInterceptor, responseInterceptor } from './interceptors';

const Api = axios.create({
  baseURL: Environment.baseUrl,
  withCredentials: true,
});

// Attach CSRF token to mutating requests (POST, PUT, DELETE, PATCH)
Api.interceptors.request.use(csrfInterceptor);

Api.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);

export { Api };